import sha1 from 'js-sha1'
import { get, post } from '@/common/services/request.js'
import {
  getWebToken,
  syncUserInfo,
  getUserId,
  removeUserInfo,
  syncOrgId,
  syncShopId
} from '@/common/utils/common'
import { formatRole } from '@/common/utils/permission'
import router, { resetRouter } from '@/router'
import { ZM_ROOT } from '@/common/constants'

const state = {
  uid: getUserId && getUserId(),
  token: getWebToken && getWebToken(),
  name: '',
  avatar: '',
  roles: [],
  userCurrentOrg: {},
  userOrgList: [],
  userName: '',
  shopInfoList: [],
  currentShop: {}
}

const mutations = {
  SET_UID: (state, uid) => {
    state.uid = uid
  },
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_CURRENT_ORG: (state, userCurrentOrg) => {
    state.userCurrentOrg = Object.assign({}, state.userCurrentOrg, userCurrentOrg)
  },
  SET_ORG_LIST: (state, userOrgList) => {
    state.userOrgList = userOrgList
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  },
  SET_SHOP_INFO_LIST: (state, shopInfoList) => {
    state.shopInfoList = shopInfoList
  },
  SET_CURRENT_SHOP: (state, currentShop) => {
    state.currentShop = currentShop
  },
  CLEAR_USER_INFO: state => {
    state.token = ''
    state.roles = []
    state.userCurrentOrg = {}
    state.userOrgList = []
    state.shopInfoList = []
    state.currentShop = {}
  }
}

const actions = {
  // get sms code
  getSmsCode({ commit }, data) {
    const { account, smsType } = data
    return post('user.requestSmsPassword', {
      mobile: account,
      smsType: smsType // "REGISTER"
    })
  },
  // user login with pass
  loginWithPass({ commit, dispatch }, userInfo) {
    const { account, password } = userInfo
    return new Promise((resolve, reject) => {
      post('user.wapLogin', {
        mobile: account.trim(),
        password: sha1(password)
      })
        .then(response => {
          const { success, data } = response
          if (success) {
            commit('SET_TOKEN', data[0].token)
            commit('SET_UID', data[0].userId)
            syncUserInfo({
              uid: data[0].userId,
              token: data[0].token
            })
            // dispatch('tagsView/delAllViews')
            resolve(data[0])
          } else {
            reject({
              msg: '登录失败'
            })
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // user login with code
  loginWithCode({ commit, dispatch }, userInfo) {
    const { account, code } = userInfo
    return new Promise((resolve, reject) => {
      post('user.dynamicPasswordLogin4Wap', {
        _pn: account.trim(),
        _dyn: code
      })
        .then(response => {
          const { data } = response
          commit('SET_TOKEN', data[0].token)
          commit('SET_UID', data[0].uid)
          // dispatch('tagsView/delAllViews')
          syncUserInfo({
            uid: data[0].uid,
            token: data[0].token
          })
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  // get user org info and role menu
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      get('organization.getUserOrgInfo', {
        orgIdentityType: 20
      })
        .then(res => {
          if (!res.success) {
            reject({ message: '获取商家信息失败' })
          } else {
            let currentOrg = res.data[0] && res.data[0].userCurrentOrg
            let userOrgList = res.data[0] && res.data[0].userOrgList
            let userName = res.data[0] && res.data[0].userName
            commit('SET_CURRENT_ORG', currentOrg)
            commit('SET_ORG_LIST', userOrgList)
            commit('SET_NAME', userName)
            if (!currentOrg) {
              reject({ message: '当前账号没有商家信息' })
            }
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  getMenuList({ commit, state }) {
    return new Promise((resolve, reject) => {
      get('organization.getUserRoleAndMenu', {
        orgIdentityType: 20
      })
        .then(async response => {
          const { success, data } = response
          if (!success) {
            reject({ message: '获取菜单失败', code: 0 })
          } else {
            let currentOrg = (data[0] && data[0].userCurrentOrg) || {}
            let userOrgList = data[0] && data[0].userOrgList
            let userName = data[0] && data[0].userName
            syncOrgId(currentOrg)
            commit('SET_CURRENT_ORG', currentOrg)
            commit('SET_ORG_LIST', userOrgList)
            commit('SET_NAME', userName)

            const { menuWithChildDOList } = data[0]
            const roles = formatRole(menuWithChildDOList)
            if (!roles || roles.length <= 0) {
              reject('getInfo: roles must be a non-null array!')
            }
            commit('SET_ROLES', roles)

            //处理店铺逻辑
            const res = await get('shop.seller.getShopListByUserId')
            if (
              res.success &&
              res.data &&
              res.data[0] &&
              res.data[0].shopInfoList &&
              res.data[0].shopInfoList.length > 0
            ) {
              let shopInfoList = res.data[0].shopInfoList
              let currentShop = shopInfoList.find(ele => ele.loginStatus == 10)
              commit('SET_SHOP_INFO_LIST', shopInfoList)
              commit('SET_CURRENT_SHOP', currentShop)
              currentShop && syncShopId(currentShop)

              resolve({
                ...data[0],
                roles
              })
            } else {
              reject({ message: '获取店铺失败' })
            }
          }
        })
        .catch(error => {
          console.log(error)
          reject({ message: '获取菜单失败', code: 0 })
        })
    })
  },

  /** 用户切换机构 */
  userChangeOrg({ commit }, orgId) {
    return new Promise((resolve, reject) => {
      get('organization.userChangeOrg', {
        orgId
      })
        .then(response => {
          const { success, data } = response
          resolve({
            ...data[0]
          })
          if (!success) {
            if (data.stat && data.stat.stateList[0] && data.stat.stateList[0].code === 0) {
              resolve({
                ...data[0]
              })
            } else {
              reject(new Error('切换机构失败'))
            }
          } else {
            resolve({
              ...data[0]
            })
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  //切换店铺
  changeUserShop: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      post('shop.seller.changeSessionShopId', {
        request: { orgId: payload.orgId, shopId: payload.shopId }
      })
        .then(res => {
          const { success, data } = res
          if (success && data && data[0] && data[0].value) {
            resolve()
          } else {
            reject(new Error('切换机构失败'))
          }
        })
        .catch(e => {
          reject(e)
        })
    })
  },
  //获取店铺列表
  async getShopInfoList({ commit }) {
    try {
      const { success, data } = await get('shop.seller.getShopListByUserId')
      if (success && data && data[0] && data[0].shopInfoList && data[0].shopInfoList.length > 0) {
        let shopInfoList = data[0].shopInfoList
        let currentShop = shopInfoList.find(ele => ele.loginStatus == 10)
        commit('SET_SHOP_INFO_LIST', shopInfoList)
        commit('SET_CURRENT_SHOP', currentShop)
        currentShop && syncShopId(currentShop)
      } else {
        console.log('获取店铺失败')
      }
    } catch (e) {
      console.log(e)
    }
  },
  // user logout
  logout({ commit, state }) {
    commit('CLEAR_USER_INFO')
    removeUserInfo()
    resetRouter()
    const href = window.location.href
    const isDev = !href.match(/\.zhaogang(.*)\.com/)
    if (!isDev) {
      const jumpLink = href.split('/#')[0]
      const url = encodeURIComponent(`${jumpLink}/#/`)
      window.location.href = `${ZM_ROOT}/logout?loginType=0&jump=${url}`
    } else {
      router.push(`/login`)
    }
  },

  // remove token
  resetToken({ commit }) {
    commit('CLEAR_USER_INFO')
    removeUserInfo()
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
